
import {BaseEntity} from "../base-entity";
import {Contact} from "../contact";
import {User} from "../user";

export class StaffProfiles extends BaseEntity{
    constructor(staffProfiles? : StaffProfiles) {
        super(staffProfiles);
        if(staffProfiles) {

            if (staffProfiles.contact) {
                this.contact = new Contact(staffProfiles.contact);
            }

            if(staffProfiles.user){
                this.user = new User(staffProfiles.user);
            }
        }
    }

    id : number;
    contact : Contact;
    userId : string;
    role: string;
    user: User;

}
